import React from 'react';
import { Row, Col } from 'antd';

function Footer() {
  return (
    <footer id="footer" className="dark">
      <div className="footer-wrap">
        <Row>
          <Col lg={6} sm={24} xs={24}>
            <div className="footer-center">
              <h2>Groomer Express</h2>
              <div>
                <a
                  target="_blank "
                  href="https://github.com/orgs/Lambda-School-Labs/teams/labspt12-express_groomer-teama/repositories"
                >
                  Groomer Express Pro
                </a>
              </div>
              <div>
                <a
                  target="_blank "
                  href="https://github.com/orgs/Lambda-School-Labs/teams/labspt12-express_groomer-teama/repositories"
                >
                  Groomer Express
                </a>
              </div>
              <div>
                <a href="https://github.com/orgs/Lambda-School-Labs/teams/labspt12-express_groomer-teama/repositories">
                  GitHub Repo
                </a>
              </div>
              <div>
                <a href="https://github.com/orgs/Lambda-School-Labs/teams/labspt12-express_groomer-teama/repositories">
                  GitHub Repo
                </a>
                <span> - </span>
                Groomer Express
              </div>
              <div>
                <a
                  target="_blank "
                  href="https://github.com/orgs/Lambda-School-Labs/teams/labspt12-express_groomer-teama/repositories"
                >
                  Groomer Express
                </a>
              </div>
            </div>
          </Col>
          <Col lg={6} sm={24} xs={24}>
            <div className="footer-center">
              <h2>Groomer Express</h2>
              <div>
                <a href="https://github.com/orgs/Lambda-School-Labs/teams/labspt12-express_groomer-teama/repositories">
                  Groomer Express
                </a>
              </div>
              <div>
                <a
                  target="_blank"
                  rel="noopener"
                  href="https://github.com/orgs/Lambda-School-Labs/teams/labspt12-express_groomer-teama/repositories"
                >
                  Groomer Express
                </a>
              </div>
              <div>
                <a
                  target="_blank"
                  rel="noopener"
                  href="https://github.com/orgs/Lambda-School-Labs/teams/labspt12-express_groomer-teama/repositories"
                >
                  Groomer Express
                </a>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </footer>
  );
}

export default Footer;
